import React, { memo } from "react";
import useStyles from "./styles";
import ImagesConfig from "components/ImagesConfig";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";

const ProductGiftLevel = props => {
	const classes = useStyles();
	const { product, products, quantity } = props;

	return (
		<Grid classes={{ root: classes.product }}>
			<Grid classes={{ root: classes.image }}>
				<ImagesConfig
					image={product?.image}
					imageDefault={Images.icProductDefault}
					width={45}
					height={45}
				/>
			</Grid>
			<Grid classes={{ root: classes.nameProduct }}>
				<span style={{ textTransform: "lowercase" }}>
					{quantity || 0} {"lẻ"}
				</span>{" "}
				{products?.productsName || "-"}
			</Grid>
		</Grid>
	);
};

export default memo(ProductGiftLevel);
